import { useState } from "react";

import Infocontact from "../components/infocontact";

const Contact = ({
  nom,
  prenom,
  adresse,
  codePostal,
  ville,
  Pays,
  Tel,
  Email,
}) => {
  const [nomF, setNomF] = useState("");
  const [prenomF, setPrenomF] = useState("");
  const [sujet, setSujet] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [messageStatus, setMessageStatus] = useState(null);
  const [isError, setIsError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const tel = telephone.replace(/\D/g, "");

  const prenomMaj = prenomF.charAt(0).toUpperCase() + prenomF.slice(1).toLowerCase();
  const nomMaj = nomF.charAt(0).toUpperCase() + nomF.slice(1).toLowerCase();

    const data = {
      nom: nomMaj,
      prenom: prenomMaj,
      email,
      telephone: tel,
      sujet,
      message,
    };

console.log("Données à envoyer :", data);
 

    if (tel.length !== 10) {
      setMessageStatus("Le numéro de téléphone doit comporter 10 chiffres.");
      setIsError(true);
      return;
    }

    try {
      const response = await fetch("/api/mail/send", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      console.log("Réponse serveur :", result);
      setMessageStatus("Message envoyé avec succès !");
      setTimeout(()=>{
        setMessageStatus("");
      },2000)

     
      setIsError(false);
    } catch (error) {
      console.error("Erreur envoi :", error);
      setMessageStatus("Erreur lors de l'envoi du message.");
      setIsError(true);
    }
  };

  const handleChangeTelephone = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setTelephone(value);
  };

  return (
    <main style={{ paddingTop: "100px" }}>
      <div className="center">
        <h2 className="title-h2 fw-semibold">Contact</h2>
        <p>
          Pour me contacter en vue d'un entretien ou d'une future collaboration,
          merci de remplir le formulaire de contact
        </p>
        <hr></hr>
      </div>
      <section className="cont-A d-flex flex-wrap justify-content-center gap-4 p-4 border border-secondary-subtle mt-3 mb-3 shadow-lg bg-white w-90 mx-auto">
        <form onSubmit={handleSubmit} className="cont-A-1">
          <p className="title-app">Formulaire de contact</p>
          <input
            type="text"
            placeholder="Votre nom"
            id="nomF"
            value={nomF}
            onChange={(e) => {
              setNomF(e.target.value);
            }}
            required
          />
          <input
            type="text"
            placeholder="Votre prenom"
            id="prenomF"
           value={prenomF}
            onChange={(e) => setPrenomF(e.target.value)}
            required
          ></input>

          <input
            type="email"
            placeholder="Votre adresse mail"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          ></input>
          <input
            type="tel"
            placeholder="Votre numero de telephone"
            id="telephone"
            value={telephone}
            onChange={handleChangeTelephone}
            inputMode="numeric"
            maxLength={10}
            required
          ></input>
          <input
            type="text"
            placeholder="Sujet"
            id="sujet"
            value={sujet}
            onChange={(e) => setSujet(e.target.value)}
            required
          ></input>

          <textarea
            placeholder="Votre message"
            id="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          ></textarea>
          <button type="submit" className="btn btn-primary align-self-center">
            Envoyer
          </button>

       

          {messageStatus && (
            <div
              className={`alert ${isError ? "alert-danger" : "alert-success"} mt-3`}
              role="alert"
            >
              {messageStatus}
            </div>
          )}
        </form>
        <article className="cont-A-2">
          <p className="title-app">Mes coordonnées</p>
          <p>
            {prenom} {nom}
          </p>
          <Infocontact
            nom={nom}
            prenom={prenom}
            adresse={adresse}
            codePostal={codePostal}
            ville={ville}
            Pays={Pays}
            Tel={Tel}
            Email={Email}
          />
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2706.335771325818!2d55.500041073706626!3d-21.26411098123294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x21787551e03dcbdb%3A0x589065505de775d8!2s200%20Rue%20Emmanuel%20Burel%2C%20Le%20Tampon%2097430%2C%20La%20R%C3%A9union!5e1!3m2!1sfr!2sfr!4v1768206811839!5m2!1sfr!2sfr"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </article>
      </section>
    </main>
  );
};

export default Contact;
